import { ButtonHTMLAttributes, useState } from 'react';

/**
 * IconButton — quiet square icon action (theme toggle, sidebar collapse,
 * close buttons in headers). Transparent at rest in --text-dim; hover lifts
 * to --surface and brightens to --text.
 */
export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Tabler icon name (without the `ti-` prefix), e.g. 'sun'. */
  icon: string;
  /** Icon font size in px. Default 14. */
  iconSize?: number;
  /** Accessible label. */
  label?: string;
}

export function IconButton({ icon, iconSize = 14, label, style, ...props }: IconButtonProps) {
  const [hover, setHover] = useState(false);
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        background: hover ? 'var(--surface)' : 'transparent',
        border: 'none',
        cursor: 'pointer',
        color: hover ? 'var(--text)' : 'var(--text-dim)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 6,
        borderRadius: 6,
        transition: 'background .15s, color .15s',
        ...style,
      }}
      {...props}
    >
      <i className={`ti ti-${icon}`} style={{ fontSize: iconSize }} />
    </button>
  );
}

export default IconButton;
